/**
 * Enter/exit motion for the Talk-to-Heidi dock.
 *
 * The panel grows out of, and settles back into, the trigger in the
 * bottom-right corner rather than blinking in and out. The exit matters most:
 * the panel closes on its own when the mic is handed to visit transcription,
 * and an instant disappearance there read as a crash.
 */

const PANEL_HIDDEN = { opacity: 0, y: 10, scale: 0.97 };
const PANEL_SHOWN = { opacity: 1, y: 0, scale: 1 };
const ENTER_TRANSITION = { type: 'spring', stiffness: 420, damping: 34 } as const;
// Leaving is a tween, not a spring: an exit should be quick and final, and a
// spring's overshoot on the way out reads as a bounce nobody asked for.
const EXIT_TRANSITION = { duration: 0.18, ease: [0.165, 0.84, 0.44, 1] } as const;

/** Fades only under `prefers-reduced-motion` — the transform is decoration. */
export const panelMotionProps = (reduceMotion: boolean | null) => {
  const hidden = reduceMotion ? { opacity: 0 } : PANEL_HIDDEN;
  return {
    initial: hidden,
    animate: reduceMotion ? { opacity: 1 } : PANEL_SHOWN,
    exit: { ...hidden, transition: EXIT_TRANSITION },
    transition: reduceMotion ? EXIT_TRANSITION : ENTER_TRANSITION,
  };
};
